export const Black = "#1F2023";
export const Gray = "#3B3F42";
export const LightGray = "#555555";
export const Blue = "#1A71E7";
